import { c as _c } from "react/compiler-runtime";
import { Divider } from '@sola/ark-core/atoms/divider/divider.tsx';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import type { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { CommitmentCardPayment } from '../commitment-card-payment/commitment-card-payment.tsx';
export interface MakeAPaymentSectionProps {
  title: string;
  description: string;
  commitments: GraphQLCommitment[];
  alertMessage?: string;
}
export const MakeAPaymentSection: React.FC<MakeAPaymentSectionProps> = t0 => {
  const $ = _c(16);
  const {
    title,
    description,
    commitments,
    alertMessage
  } = t0;
  if (commitments.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== title) {
    t1 = <span className="heading-xs">{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <span className="body-sm body-neutral-mild">{description}</span>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-snug-lg">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== alertMessage) {
    t4 = alertMessage && <Alert message={<IntlBlock i18nKey={alertMessage} />} />;
    $[7] = alertMessage;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== commitments) {
    t5 = commitments.map(_temp);
    $[9] = commitments;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider purpose="neutral" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t7 = <>{t3}{t4}{t5}{t6}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
function _temp(commitment) {
  return <CommitmentCardPayment key={commitment.internalId} commitment={commitment} />;
}